import { BitrixVue } from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from 'vpl.tas';
import { ItemEditBtns } from 'vpl.tas';

export const ServicesDetail = {
    components: {
        ItemEditBtns
    },
    props: {
        structKey: [String, Number],
    },
    computed: {
        ...mapState(vplSiteStore, ['struct', 'SITE_TEMPLATE_PATH'])
    },
    mounted(){
        if($(this.$el).find('.js-proj-slider').length){
            let mpSwiperServ = new Swiper('.js-proj-slider', {
                    loop: true,
                    grabCursor: true,
                    slidesPerView: 1,
                    spaceBetween: 30,
                    autoplay: {
                    delay: 3000
                    },
                    pagination: {
                    el: ".js-proj-pag",
                    type: "bullets",
                    clickable: true
                    },
                    navigation: {
                    nextEl: ".js-proj-btn-next",
                    prevEl: ".js-proj-btn-prev"
                    }
            });
        }

        let choosenService = this.struct[this.structKey].componentData.ITEM.NAME;
        $('select[name=form_dropdown_SIMPLE_QUESTION_966]').each(function(){
            let choosenOption = false;
            $(this).find('option').each(function(){
                if($(this).text() == choosenService){
                    choosenOption = $(this).val();
                }
            });
            if(choosenOption !== false){
                $(this).val(choosenOption);
                if( $(this).next('.nice-select').length) {
                    $(this).niceSelect('destroy');
                }
                $(this).niceSelect();
            }
        });

        if($(this.$el).find('[data-fancybox]').length){
            $(this.$el).find('[data-fancybox]').fancybox({
                loop: true,
            });
        }
    },
    methods: {
        zoomIn(){
            $(this.$el).find('.swiper-slide-active').find('a').trigger('click');
        },
        showModalForm(){
            $('#order').modal();
        }
    },
    template: `
<div style="display: contents;">
<section class="section section--first">
    <div class="container">
        <div class="projects__intra projects__intra--serv">
            <div class="projects__intra-text content">
                <div v-if="this.struct[this.structKey].componentData.ITEM.UPPER_TEXT" style="display: contents;" v-html="this.struct[this.structKey].componentData.ITEM.UPPER_TEXT">
                </div>
                <a href="#" class="btn btn--green" @click.prevent="showModalForm()">Отправить заявку</a>
            </div>
            <div v-if="this.struct[this.structKey].componentData.ITEM.GALLERY.length" class="projects__intra-rightside js-proj-slider-wp">
                <div class="projects__intra-rightside-inner">
                    <div class="swiper projects__intra-slider js-proj-slider">
                        <div class="swiper-wrapper">
                            <div v-for="galItem in this.struct[this.structKey].componentData.ITEM.GALLERY" class="swiper-slide">
                                <a :href="galItem.BIG" class="projects__intra-slider-img" data-fancybox="project-detail">
                                    <img :src="galItem.MEDIUM" :alt="this.struct[this.structKey].componentData.ITEM.NAME" :title="this.struct[this.structKey].componentData.ITEM.NAME" loading="lazy">
                                </a>
                            </div>
                        </div>
                    </div>
                    <a href="#" class="zoom js-proj-zoom" @click.prevent="zoomIn()">
                        <svg class="icon icon-zoom"><use xlink:href="#icon-zoom"></use></svg>
                    </a>
                    <div class="slider-arrows">
                        <div class="swiper-button-prev slider-btn js-proj-btn-prev">
                            <svg class="icon icon-arrow-prev"><use xlink:href="#icon-arrow-prev"></use></svg>
                        </div>
                        <div class="swiper-button-next slider-btn js-proj-btn-next">
                            <svg class="icon icon-arrow-next"><use xlink:href="#icon-arrow-next"></use></svg>
                        </div>
                    </div>
                </div>
                <div class="swiper-pagination js-proj-pag"></div>
            </div>
            <div v-else class="projects__intra-rightside">
                <div class="projects__intra-rightside-inner">
                    <div class="swiper projects__intra-slider">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide">
                                <span class="projects__intra-slider-img no-photo">
                                    <img :src="this.SITE_TEMPLATE_PATH + '/img/svg/no-photo.svg'" :alt="this.struct[this.structKey].componentData.ITEM.NAME" :title="this.struct[this.structKey].componentData.ITEM.NAME" loading="lazy">
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section v-if="this.struct[this.structKey].componentData.ITEM.TEXT" class="section section--gray2">
    <div class="container">
        <div class="text-block content" v-html="this.struct[this.structKey].componentData.ITEM.TEXT">
        </div>
    </div>
</section>
</div>
    `
}